import * as analytic from '@anm/analytic';
import useSwitchState from '@anm/hooks/useSwitchState';
import { useCallback, useEffect, FC } from 'react';

import vtConfig from '../../config';
import useWorkspaceParam from '../my-projects/MyStreamsSection/RightButtons/useWorkspaceParam';

import TwoOptionsDialog from './TwoOptionsDialog';
import useOpenGuard from './hooks/useOpenGuard';

export type OpenTwoOptionsDialogProps = {};

const { urls, isProd } = vtConfig();
const templateId = isProd ? 'ca55a262cdb50556c5733bec' : '9a1c315f64d0ef939a4f8615';

const OpenTwoOptionsDialog: FC<OpenTwoOptionsDialogProps> = () => {
  const [canOpen, onClose] = useOpenGuard();
  const [isModal, openModal, closeModal] = useSwitchState(canOpen);
  const workspaceParam = useWorkspaceParam('?');

  const handleStudioOpen = useCallback(() => {
    analytic.trackOnBoardTwoOptionsOpenStudio();
  }, []);
  const handleEditorOpen = useCallback(() => {
    analytic.trackOnBoardTwoOptionsOpenEditor();
  }, []);
  const handleModalClose = useCallback(() => {
    analytic.trackOnBoardTwoOptionsClose();
    closeModal();
    onClose();
  }, []);

  useEffect(() => {
    if (canOpen) {
      openModal();
      analytic.trackOnBoardTwoOptionsShow();
    }
  }, [canOpen]);

  if (!isModal) return null;

  return (
    <TwoOptionsDialog
      editorLink={`${urls.editor}/#r=${templateId}`}
      studioLink={`${urls.streamingStudio}my-room${workspaceParam}`}
      onEditorOpen={handleEditorOpen}
      onStudioOpen={handleStudioOpen}
      onModalClose={handleModalClose}
    />
  );
};

export default OpenTwoOptionsDialog;
